const ONE_HOUR = 1000 * 60 * 60;
class Event {

    constructor() {
    }

    static getResourceGroupsKey() {
        return 'resourceGroup_name';
    }


    static getCategoryKey() {
        return 'category';
    }

    static getAuthorityKey() {
        return 'authority_identifier';
    }

    static getSeverityKey() {
        return 'severity';
    }

    static getTitleKey() {
        return 'message';
    }


    static getTimeRangeKey() {
        return 'created';
    }

    static getSeverityOptions() {
        return [
            { label: 'Info', value: 'INFO' },
            { label: 'Warning', value: 'WARNING' },
            { label: 'Error', value: 'ERROR' },
        ];
    }

    static getTimeOptions() {
        return [
            { name: 'Last 1 hour', value: (ONE_HOUR).toString() },
            { name: 'Last 24 hours', value: (ONE_HOUR * 24).toString() },
            { name: 'Last week', value: (ONE_HOUR * 24 * 7).toString() },
        ];
    }

    static fromRaw(raw) {
        let event = new Event();
        event.category = raw.category;
        event.created = raw.created;
        event.details = raw.details;
        event.message = raw.message;
        event.severity = raw.severity;
        event.authority = raw.authority;

        return event;
    }

    toRaw() {
        return {
            category: this.category,
            created: this.created,
            details: this.details,
            message: this.message,
            severity: this.severity,
            authority: this.authority,
        }
    }
}

module.exports = Event;


// WEBPACK FOOTER //
// ./src/azurebackup/model/Event.js